/**
 * PGSS-5744: the SKU field on the product form. A stock product's SKU is generated when it is created, and only an
 * Admin (or Super Admin) can change it afterwards; the backend ignores anyone else's change, so the field is
 * read-only for them. Other products keep the field as it was.
 */
export function skuFieldState({ isStockProduct, isNew, canManage, isReadOnly }) {
  if (!isStockProduct) return { readOnly: isReadOnly, helperText: '' };
  if (isNew) return { readOnly: true, helperText: 'Generated when you save, from colour, type, sub type, size and polish.' };
  if (!canManage) return { readOnly: true, helperText: 'Only an Admin can change a SKU.' };
  return { readOnly: isReadOnly, helperText: 'Changing a SKU means its printed labels need reprinting.' };
}
